import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

/**
 * Parallax Section Component
 * Provides scroll-triggered fade-in and slide-up animations
 */
const ParallaxSection = ({ 
  children, 
  className = '', 
  delay = 0,
  animation = 'fade-up' // 'fade-up', 'fade-left', 'fade-right', 'scale', 'fade'
}) => {
  const { elementRef, isVisible } = useScrollAnimation(0.1);

  const getAnimationClass = () => {
    const baseClasses = 'transition-all duration-1000 ease-out';
    
    if (!isVisible) {
      switch (animation) {
        case 'fade-up':
          return `${baseClasses} opacity-0 translate-y-20`;
        case 'fade-left':
          return `${baseClasses} opacity-0 -translate-x-20`;
        case 'fade-right':
          return `${baseClasses} opacity-0 translate-x-20`;
        case 'scale':
          return `${baseClasses} opacity-0 scale-90`;
        case 'fade':
        default:
          return `${baseClasses} opacity-0`;
      }
    }
    
    return `${baseClasses} opacity-100 translate-y-0 translate-x-0 scale-100`;
  };

  return (
    <div 
      ref={elementRef}
      className={`${getAnimationClass()} ${className}`}
      style={{ 
        transitionDelay: `${delay}ms`
      }}
    >
      {children}
    </div>
  );
};

export default ParallaxSection;
